export const STRINGS = {
	TituloConfirmacaoExclusao: 'Deseja Excluir?',
	MensagemConfirmacaoExclusao: 'O registro será excluído permanentemente.',
	TituloShouldNavigate: 'Deseja Continuar?',
	MensagemShouldNavigate: 'As informações que não foram salvas serão perdidas.',
	MensagemSuccessSave: 'Registro salvo com Sucesso.',

	MaiorDoQueZero: 'Deve ser maior do que zero.',
	Obrigatorio: 'Campo obrigatório.',
	DataMaiorDoQueHoje: 'Data não pode ser anterior a hoje',
	MensagemPedidoFabricaRacao: 'Pedido criado pela fábrica de ração',
	CamposInvalidos: 'Por favor, corrija os campos inválidos.'
}
export const URLS = {
	PEDIDORACAO: 'pedido-racao/',
	SOLICITADOS: 'pedido-racao/solicitados/',
	ATRASADOS: 'pedido-racao/atrasados/',
	CANCELADOS: 'pedido-racao/cancelados/',
	ENTREGAS: 'pedido-racao/entregas/',
	CONFIRMADOS: 'pedido-racao/confirmados/',
	FINALIZADOS: 'pedido-racao/finalizados/',
	TOTAIS: 'pedido-racao/totais/',
	DETALHEPEDIDO: '/detalhePedido/',
	ESTABPROX: '/estabelecimentos-proximos/',
	SUGESTAOPEDIDO: 'pedido-racao/sugestao-pedido/',
	ATUALIZASTATUS: 'pedido-racao/atualiza-status/',
	FABRICARACAO: 'fabrica-racao/',
	RACAO: 'racao/',
	ENTRADARACAO: 'entrada-racao/',
	MODOGETBYID: '/get_pedido_by_id/',
	LOTEPRODUCAO: 'lote-producao/'
};
let models = {
	TIPOFILTROS: {
		solicitados: {
			'nr_pedidos': '',
			'exibe_marcador': false,
			'st_cor': ''
		},
		confirmados: {
			'nr_pedidos': '',
			'exibe_marcador': false,
			'st_cor': ''
		},
		atrasados: {
			'nr_pedidos': '',
			'exibe_marcador': false,
			'st_cor': ''
		},
		cancelados: {
			'nr_pedidos': '',
			'exibe_marcador': true,
			'st_cor': '#FF5429'
		},
		finalizados: {
			'nr_pedidos': '',
			'exibe_marcador': false,
			'st_cor': ''
		},
	},
	HEADERS: {
		nmProdutor: {
			text: 'Produtor',
			align: 'start',
			sortable: false,
			value: 'nmProdutor',
			class: "grey lighten-4"
		},
		nrPavilhao: {
			text: 'Pavilhão',
			align: 'start',
			sortable: false,
			value: 'nrPavilhao',
			class: "grey lighten-4"
		},
		dtDesejada: {
			text: 'Entrega Desejada',
			align: 'start',
			sortable: false,
			value: 'dtDesejada',
			class: "grey lighten-4"
		},
		dsObservacao: {
			text: 'Observação',
			align: 'start',
			sortable: false,
			value: 'dsObservacao',
			class: "grey lighten-4"
		},
		nrUep: {
			text: 'UEP',
			align: 'start',
			sortable: false,
			value: 'nrUep',
			class: "grey lighten-4"
		},
		idPedidoRacao: {
			text: 'Pedido',
			align: 'center',
			sortable: false,
			value: 'idPedidoRacao',
			class: "grey lighten-4"
		},
		dtPrevista: {
			text: 'Entrega Prevista',
			align: 'start',
			sortable: false,
			value: 'dtPrevista',
			class: "grey lighten-4"
		},
		cdStatusPedidoRacao: {
			text: 'Entregue',
			align: 'center',
			sortable: false,
			value: 'cdStatusPedidoRacao',
			class: "grey lighten-4"
		},
	},
	HEADERFINALIZADOS: {
			text: 'Entregue',
			align: 'center',
			sortable: false,
			value: 'cdStatusPedidoRacao',
			class: "grey lighten-4"
	},
	QUERYFILTROS: {
		endpoint: URLS.SOLICITADOS,
		nmProdutor: '',
		dsObservacao: '',
		nrUep: '',
		idPedidoRacao: '',
		dtPrevista: null,
		nrPavilhao: ''
	},
	PEDIDO: {
		nrPedido: 0,
		cdLoteProducao: 0,
		nmProdutor: '',
		nrUep: 0,
		nrPavilhao: '',
		dsObservacao: '',
		dtEntregaDesejada: '',
		dtPrevisaoEntrega: '',
		idFabricaRacao: 0,
		dsUltimaEnviada: '',
		historico: {
			dhStatusSolicitado: '',
			dhStatusConfirmado: '',
			listaConfirmado: [],
			dtPrevista: '',
			dhStatusSaiuEntrega: '',
			dhStatusEntrega: '',
			dtEntrega: '',
			hrEntrega: '',
			dhStatusCancelado: ''
		},
		racoes: [],
		nrNotaFiscal: '',
		qtItensNF: 0,
		loteRacao: '',
		cdRacaoSelecionada: 0,
		qtSugestao: -1,
		dsTipoRacao: '',
		qtRacaoSilo: -1,
		qtSiloDisponivel: -1,
		dsObservacaoCancelado: '',
		blPedidoFabrica: false
	},
}
models.HEADERSTABLE = {
            [URLS.SOLICITADOS]: [models.HEADERS.nmProdutor, models.HEADERS.nrPavilhao, models.HEADERS.dtDesejada, models.HEADERS.dsObservacao, models.HEADERS.nrUep, models.HEADERS.idPedidoRacao],
            [URLS.CONFIRMADOS]: [models.HEADERS.nmProdutor, models.HEADERS.nrPavilhao, models.HEADERS.dtPrevista, models.HEADERS.dsObservacao, models.HEADERS.nrUep, models.HEADERS.idPedidoRacao],
            [URLS.ATRASADOS]: [models.HEADERS.nmProdutor, models.HEADERS.nrPavilhao, models.HEADERS.dtPrevista, models.HEADERS.dsObservacao, models.HEADERS.nrUep, models.HEADERS.idPedidoRacao],
            [URLS.CANCELADOS]: [models.HEADERS.nmProdutor, models.HEADERS.nrPavilhao, models.HEADERS.dtPrevista, models.HEADERS.dsObservacao, models.HEADERS.nrUep, models.HEADERS.idPedidoRacao],
            [URLS.FINALIZADOS]: [models.HEADERS.nmProdutor, models.HEADERS.nrPavilhao, models.HEADERS.dtPrevista, models.HEADERS.dsObservacao, models.HEADERS.nrUep, models.HEADERS.idPedidoRacao, models.HEADERS.cdStatusPedidoRacao]
};
export const MODELS = models

import moment from 'moment';
export const RULES = {
	MIN_0: (v) => v > 0 ? true : STRINGS.MaiorDoQueZero,
	OBRIGATORIO: (v) => !v ? STRINGS.Obrigatorio : true,
	MAIOR_HOJE: (v) => moment().add(-1,'days').isBefore(moment(v, 'DD/MM/YYYY', true)) ? true : STRINGS.DataMaiorDoQueHoje
}